import { extractData, notify } from '../utils/index_tagging_tool'
import { api } from '../utils/index'

const prefix = '/tagging-tool/'

export const createDimensionGroup = (data) => {
  return api.post(prefix + 'dimension-groups/', data).then(extractData)
}

export const deleteDimensionGroup = (data) => {
  return api.delete(prefix + 'dimension-groups/', {data: data})
      .then(extractData)
}

export const getDimensionGroups = () => {
  return api.get(prefix + `dimension-groups/`).then(extractData)
}

export const getDimensionGroupsDetail = (name) => {
  return api.get(prefix + `dimension-groups/${name}/`).then(extractData)
}

export const getLanguageGroupInfo = (name) => {
  return api.get(prefix + `language-groups/info/${name}/`).then(extractData)
}

export const createSavedDimension = (data) => {
  return api.post(prefix + 'saved-dimensions/', data).then(extractData)
}

export const deleteSavedDimension = (data) => {
  return api.delete(prefix + 'saved-dimensions/', {data: data})
      .then(extractData)
}

export const updateSavedDimension = (dimension) => {
  return api.put(`${prefix}saved-dimensions/${dimension.id}/`, dimension)
      .then(extractData)
}

export const saveSavedDimensionAiRegexPrompt = (dimensionId, prompt) => {
  return api
    .put(`${prefix}saved-dimensions/${dimensionId}/`, { ai_regex_dimension_description: prompt })
    .then(extractData)
}

export const runSavedDimensionAiRegexPreview = (dimensionId, data) => {
  return api
    .post(`${prefix}saved-dimensions/${dimensionId}/ai-regex-preview/`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(extractData)
}

export const getCustomDimension = (id) => {
  return api.get(`${prefix}custom-dimensions/${id}/`).then(extractData)
}

export const getCustomDimensionTags = (id) => {
  return api.get(`${prefix}custom-dimensions/${id}/tags/`).then(extractData)
}

export const getSavedDimensions = () => {
  return api.get(prefix + `dimension-groups/`).then(extractData)
}

export const getSavedDimensionTags = (id) => {
  return api.get(`${prefix}saved-dimensions/${id}/tags/`).then(extractData)
}

export const getCustomRules = (id, saved, page= 1, query) => {
  return api.get(`${prefix}custom-rules/?pk=${id}&page=${page}&saved=${saved}${query}`)
}

export const updateCustomRule = (id, data) => {
  return api.put(`${prefix}custom-rules/${id}/`, data)
}

export const addLanguageGroup = (name, data) => {
  return api.post(prefix + `language-groups/${name}/`, data).then(extractData)
}

export const updateLanguageGroup = (name, data) => {
  return api.put(prefix + `language-groups/${name}/`, data).then(extractData)
}

export const deleteLanguageGroup = (name, data) => {
  return api.delete(prefix + `language-groups/${name}/`, {data: data}).then(extractData)
}

export const getGroupEmptyTranslations = (name) => {
  return api.get(prefix + `group-translations/${name}/`).then(extractData)
}

export const updateGroupTranslationConfiguration = (name, data) => {
  return api.put(prefix + `group-translations/${name}/`, data).then(extractData)
}

export const getReportEmptyTranslations = (id) => {
  return api.get(prefix + `reports/${id}/missing_translations/`).then(extractData)
}

export const updateReportTranslationConfiguration = (name, data) => {
  return api.put(prefix + `report-translations/${name}/`, data).then(extractData)
}

export const translateDimension = (id, saved) => {
  return api.get(prefix + `translate-dimension/${id}/?saved=${saved}`).then(extractData)
}

export const saveDimensionTranslations = (id, data) => {
  return api.post(prefix + `translate-dimension/${id}/`, data).then(extractData)
}

export const updateLanguageRule = (id, data, ) => {
  return api.put(`${prefix}rule-language/${id}/`, data)
  .then((res) => {
    notify('Modifiche salvate :)', 'info')
  }, (err) => {
    let res = err.response;
    if (res.status >= 400){
      notify('Errore nella comunicazione con il server', 'error')
    }
  })
}

export const getUnsavedRules = (name) => {
  return api.get(prefix + `unsaved-rules/${name}/`, { credentials: 'include' }).then(extractData)
}

export const saveCustomRule = (id, data) => {
  return api.put(`${prefix}rule-saver/${id}/`, data).then(extractData)
  .catch((e) => {
    notify('La comunicazione con il server è stata interrotta', 'error')
  })
}

export const cloneReport = (id, data) => {
  return api.post(prefix + `reports/${id}/clone/`, data)
}

export const getReportNames = () => {
  return api.get(prefix + 'reports/names/').then(extractData)
}

export const createDependency = (data) => {
  return api.post(prefix + `dependencies/`, data)
}

export const updateDependency = (id, data) => {
  return api.put(prefix + `dependencies/${id}/`, data)
}

export const deleteDependency = (id) => {
  return api.delete(prefix + `dependencies/${id}/`)
}
